import DbBaseObject from "@shared/DbBaseObject.js";

export const ToolWorkStateStatusEnum = Object.freeze({
	DRAFT: "draft",
	IN_PROGRESS: "inProgress",
	COMPLETED: "completed",
})

export default class BaseToolWorkState extends DbBaseObject {
	toolType: string = ""
	toolInstanceId: string = ""
	ownerId: string = ""
	clientId: string = ""
	resultThreadId: string = ""
	participationSessionId: string = ""
	participationAssignmentId: string = ""
	status: string = ToolWorkStateStatusEnum.DRAFT
	enginePayload: any = null
	lifecycleEvents: any[] = []
	resultId: string = ""
	completedAt: number = null

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
